export default "__VITE_ASSET__cF4lUinG__"